import { render, staticRenderFns } from "./NoPlasticMeasureInfo.vue?vue&type=template&id=1790e15f&"
import script from "./NoPlasticMeasureInfo.vue?vue&type=script&lang=js&"
export * from "./NoPlasticMeasureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports